{
  "name": "js-alert",
  "version": "2.0.0",
  "description": "A simple JavaScript popup alert manager.",
  "main": "src/index.js",
  "type": "module",
  "scripts": {
    "test": "npm install && npm build",
    "build": "webpack",
    "prepublish": "npm run build"
  },
  "keywords": [
    "browser",
    "javascript",
    "alert",
    "popup",
    "modal"
  ],
  "author": "jjv360",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/jjv360/js-alert.git"
  },
  "devDependencies": {
    "@babel/core": "^7.20.12",
    "@babel/preset-env": "^7.20.2",
    "babel-loader": "^9.1.2",
    "webpack": "^5.75.0",
    "webpack-cli": "^5.0.1"
  },
  "dependencies": {
    "light-sanitize-html": "^1.0.2"
  }
}
